/* eslint-disable jsx-a11y/anchor-is-valid,jsx-a11y/anchor-has-content */
import {DialogBoxProps} from "common/DialogBox"
import {useFindImpactHistoryByEui} from "hooks/queries/path-tracking.query"
import dayjs from "dayjs"
import {Pagination} from "common/Pagination"
import {useRootStore} from "store/useRootStore"
import {observer} from "mobx-react"
import styled from "styled-components"
import {Fragment} from "react"
import Draggable from "react-draggable"
import {RealDevice} from "dto/realdevice/devices"

export const ImpactHistoryWindow = ({show, close}: DialogBoxProps) => {
    if (!show) return null
    return <ImpactHistoryWindowBody close={close}/>
}

export const ImpactHistoryWindowBody = observer(({show, close}: DialogBoxProps) => {
    const {dashboardStore: {selectedDevice, impactHistoryStore: {pageSize, page, setPage, setLocation}, map}} = useRootStore()
    const {data: result} = useFindImpactHistoryByEui()
    const list = result?.content || []
    const count = result?.totalElements || 0
    const panTo = (lat: number, lng: number) => {
        setLocation({lat, lng})
        map?.panTo(new kakao.maps.LatLng(lat, lng))
    }
    return (
        <Draggable handle="#impact-window">
            <div className="pop-content" style={{width: 700}}>
                <a className="delete-btn" onClick={close}/>
                <TopMenu device={selectedDevice}/>
                <div className="mainbody" style={{height: 600}}>
                    <div className="main-box">
                        <div className="grid-table2 grid-pop-table">
                            <ListHeader/>
                            <ListItemBox>
                                {list.map((path, idx) => {
                                    const date = dayjs(path.receivedAt).format("YYYY/MM/DD HH:mm")
                                    return (
                                        <Fragment key={path.id}>
                                            <div
                                                className="item">{(((page * pageSize) + 1) + idx).toLocaleString()} </div>
                                            <div className="item">
                                                <time>{date}</time>
                                            </div>
                                            <div className="item is-clickable"
                                                 onClick={() => {
                                                     panTo(path.lat || 0, path.lng || 0)
                                                 }}>
                                                <span className="tag"> 위도</span> {path.lat}
                                                <span className="tag ml-3"> 경도</span> {path.lng}
                                            </div>
                                            <div className="item has-text-link">
                                                <span className="tag has-background-link has-text-white">
                                                    {path.gradient?.x}
                                                </span>
                                                <span className="ml-1 tag has-background-link has-text-white">
                                                    {path.gradient?.y}
                                                </span>
                                            </div>
                                            {/*<div className="item has-text-info">*/}
                                            {/*    /!*<span className="tag has-background-success-dark has-text-white">*!/*/}
                                            {/*    /!*    {path.impact?.x}*!/*/}
                                            {/*    /!*    {path.impact?.y}*!/*/}
                                            {/*    /!*</span>*!/*/}
                                            {/*</div>*/}
                                        </Fragment>
                                    )
                                })}
                            </ListItemBox>
                            <Pagination changePage={(page) => {
                                setPage(page - 1)
                            }} page={page + 1} size={pageSize} total={count}/>
                        </div>
                    </div>

                </div>
            </div>
        </Draggable>
    )
})

const TopMenu = ({device}: {device: RealDevice | undefined}) => {
    return (
        <div className="topbody has-background-warning-dark is-clickable" id="impact-window">
            <div className="columns">
                <div className="column" style={{height: 65}}>
                    <div className="mt5">
                        <p className="is-size-3">
                            <span className="icon">
                                <i className="fas fa-history"/>
                            </span>
                            <span className="ml-3">{device?.name}</span>
                            {/*<span className="ml-3" style={{fontSize: 15}}>(이동경로 추적 정보)</span>*/}
                            <span className="ml-3" style={{fontSize: 15}}>(넘어짐감지 기록(이력))</span>
                        </p>
                        <p className="is-size-2"/>
                    </div>
                </div>
                <div style={{position: 'absolute', right: 0, bottom: 0}}>
                    <div className="tabs is-boxed2 is-right">
                        <ul>
                            <li className="is-active">
                                <a><span>상세정보</span></a>
                            </li>
                            {/*<li>*/}
                            {/*    <a><span className="">충격감지기록</span></a>*/}
                            {/*</li>*/}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

const ListHeader = () => {
    return (
        <ListHeaderBox>
            <div className="item ">순번</div>
            <div className="item">날짜</div>
            <div className="item ">위치</div>
            <div className="item">기울기</div>
            {/*<div className="item">충격</div>*/}
        </ListHeaderBox>
    )
}

const ListHeaderBox = styled.header`
  width: 100%;
  display: grid;
  color: #353536;
  border: 0;
  background: #e9f0f5;
  grid-template-columns: 8% 25% auto 15%;
`

const ListItemBox = styled.div`
  height: 450px;
  overflow-y: auto;
  vertical-align: middle;
  font-size: 0.9rem;
  text-align: center !important;
  color: #353536;
  display: grid;
  //grid-template-columns: 8% 25% auto 10% 10%;
  grid-template-columns: 8% 25% auto 15% ;
  border-bottom: 1px solid #f2f4f4;

  &:first-child {
    border: 0;
  }
`